export default __webpack_public_path__ + "static/media/00.4c61b9ae.jpg";